




import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'EduTitle',
  props: { blok: { type: Object } },
});
